const theme = {
    colors:{
        primary: "#003580",
        primaryBtn: "#0071c2",
        secondary: "#febb02",
        white: "#fff",
        offWhite: "#f7f7f7",
        lightgray: "#d3d3d3",
        gray: "#3d3a3a",
        green: "#008000",
        lightblue: "#e8f2ff",
    },

    fontSizes: {
        fs0: "0.7rem",
        fs1: "1rem",
        fs2: "1.5rem",
        fs3: "2rem",
        fs4: "2.5rem"
    },
    boxShadow: {
        low: "2px 2px 4px #2f303059",
        high: "2px 2px 4px #2f303059"
    }

}

export default theme;